import React, { useEffect, useRef } from 'react'
import { useMutation } from '@apollo/client';
import { useNavigate } from 'react-router-dom';
import { GlobalLoader } from '../../../theme/icons'
import { HelmetSEO } from '../../../components/common'
import { PSP_SSO_VERIFY } from '../../../grapghQl/queries/auth';
import { encrypt } from '../../../utils/crypto';
import { useToasts } from '../../../components/Toast';
import { loginSuccess } from '../../../redux/features/auth/authSlice';
import { useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
import { SEO } from '../../../utils/seo';

const VERIFY_SESSION_KEY = 'saml-sso-verify';

const VerifySamlSso = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { setToastMessage } = useToasts();
    const { formatMessage } = useIntl();
    const hasStartedVerify = useRef(false);
    const [verifySSO, { loading }] = useMutation(PSP_SSO_VERIFY);

    useEffect(() => {
        if (hasStartedVerify.current) {
            return;
        }

        hasStartedVerify.current = true;
        window.history.replaceState({}, '', window.location.pathname);

        const processVerify = async () => {
            sessionStorage.setItem(VERIFY_SESSION_KEY, 'pending');

            try {
                const { data } = await verifySSO();
                const { pspSsoLogin } = data || {};

                if (!pspSsoLogin?.authToken) {
                    navigate('/saml-error?error_code=SAML-005', { replace: true });
                    return;
                }

                const loginPayload = { ...pspSsoLogin, region: pspSsoLogin?.region || 'India' };
                localStorage.removeItem('token');
                localStorage.setItem('token', encrypt(loginPayload));
                dispatch(loginSuccess(loginPayload));
                setToastMessage({ message: formatMessage({ id: 'LOGIN.SUCCESS.MESSAGE' }), variant: 'success' });
                navigate('/dashboard');
            } catch {
                navigate('/saml-error?error_code=SAML-005', { replace: true });
            } finally {
                sessionStorage.removeItem(VERIFY_SESSION_KEY);
            }
        };

        processVerify();
    }, [navigate, dispatch, setToastMessage, verifySSO, formatMessage]);

    return (
        <div className='flex flex-col justify-center items-center h-full'>
            <HelmetSEO content={SEO['VERIFY-SSO']} />
            {loading && <GlobalLoader />}
        </div>
    )
}

export default React.memo(VerifySamlSso)
